<template>
  <!-- Content -->
  <div class="active-chat page-list-role">
    <div class="chat-navbar">
      <header class="chat-header">
        <div class="d-flex align-items-center">
          <div class="sidebar-toggle d-block d-lg-none mr-1">
            <feather-icon
                icon="MenuIcon"
                class="cursor-pointer"
                size="21"
                @click="$emit('set-mq-shall-show-left-sidebar', true)"
            />
          </div>
          <b-avatar variant="info" size="36" class="mr-1">
            <feather-icon :icon="curData.icon ? curData.icon : 'AtSignIcon'"/>
          </b-avatar>
          <div class="chat-info flex-grow-1">
            <h5 class="mb-0">
              {{ curData.name }}
            </h5>
            <!-- <p class="card-text text-truncate">@{{ curData.code }}</p> -->
          </div>
        </div>
        <div
            class="d-flex justify-content-end align-items-center"
            v-if="curData.id != null"
        >
          <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="primary"
              class="mr-2"
              type="button"
              @click="updateAction()"
          >
            Lưu
          </b-button>
        </div>
      </header>
    </div>
    <!-- v-if="curData.id != null" -->
    <div class="todo-app-list">
      <vue-perfect-scrollbar
          :settings="perfectScrollbarSettings"
          class="todo-task-list-wrapper list-group scroll-area"
      >
        <draggable
            v-model="items"
            handle=".draggable-task-handle"
            tag="ul"
            class="todo-task-list media-list"
            disabled="true"
        >
          <li v-for="item in items" :key="item.id" class="todo-item">
            <!-- <feather-icon
               icon="MoreVerticalIcon"
               class="draggable-task-handle d-inline"
               /> -->
            <div class="todo-title-wrapper">
              <div class="todo-title-area">
                <div class="title-wrapper row">
                  <div class="col-md-12 chat-info flex-grow-1 mr-2">
                    <div class="d-flex justify-content-start align-items-center mb-1 cs-title">
                      <i class="fa-solid fa-tag mr-1 text-primary" style="transform: rotate(135deg)"></i>
                      <h5 class="mb-0 cs-title text-primary">
                        {{ item.name }}
                      </h5>
                    </div>
                  </div>
                  <div class="col-md-12">
                    <div
                        class="row px-05"
                    >
                      <div
                          class="col-4 px-05"
                          v-for="itemAction in item.listAction"
                          :key="itemAction.id"
                      >
                        <div class="card box-shadow-0">
                          <div class="card-body">
                            <div class="d-flex justify-content-between align-items-center">
                              <b-form-checkbox
                                  :checked="initChecked(itemAction)"
                                  @change="handleChecked($event, itemAction)"
                              />
                              <div class="chat-info flex-grow-1 mr-2">
                                <h5 class="mb-0">
                                  {{ itemAction }}
                                </h5>
                              </div>
                            </div>
                          </div>
                        </div>

                      </div>
                    </div>
<!--                    <vue-perfect-scrollbar-->
<!--                        :settings="perfectScrollbarSettings"-->
<!--                        class="todo-task-list-wrapper list-group scroll-area"-->
<!--                    >-->
<!--                      <draggable-->
<!--                          v-model="item.listAction"-->
<!--                          handle=".draggable-task-handle"-->
<!--                          tag="ul"-->
<!--                          class="todo-task-list media-list list-role"-->
<!--                          disabled="true"-->
<!--                      >-->

<!--                        <li-->
<!--                            v-for="itemAction in item.listAction"-->
<!--                            :key="itemAction.id"-->
<!--                            class="todo-item role-item"-->
<!--                            style="border: none"-->
<!--                        >-->
<!--                          <div class="todo-title-wrapper">-->
<!--                            <div class="todo-title-area">-->
<!--                              <div class="title-wrapper">-->
<!--                                <b-form-checkbox-->
<!--                                    :checked="initChecked(itemAction)"-->
<!--                                    @change="handleChecked($event, itemAction)"-->
<!--                                />-->
<!--                                <div class="chat-info flex-grow-1 mr-2">-->
<!--                                  <h5 class="mb-0">-->
<!--                                    {{ itemAction }}-->
<!--                                  </h5>-->
<!--                                </div>-->
<!--                              </div>-->
<!--                            </div>-->
<!--                          </div>-->
<!--                        </li>-->
<!--                       </draggable>-->
<!--        <div-->
<!--            class="no-results"-->
<!--            :class="{ show: items.length <= 0 }"-->
<!--        >-->
<!--          <h5>No Items Found</h5>-->
<!--        </div>-->
<!--      </vue-perfect-scrollbar>-->
    </div>
  </div>
  </div>
  </div>
  </li>
  </draggable>
  <div class="no-results" :class="{ show: items.length <= 0 }">
    <h5>No Items Found</h5>
  </div>
  </vue-perfect-scrollbar>
  </div>
  </div>
</template>

<script>
/* eslint-disable */
import store from '@/store'
import { ref, watch } from '@vue/composition-api'
import {
  BAvatar,
  BFormCheckbox,
  BInputGroup,
  BInputGroupPrepend,
  BFormInput,
  BButton,
} from 'bootstrap-vue'
import { UpdateAction } from '@/services/api/DefaultTemplate/RoleService'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import Ripple from 'vue-ripple-directive'
import draggable from 'vuedraggable'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default {
  components: {
    draggable,
    // BSV
    BAvatar,
    BFormCheckbox,
    BInputGroup,
    BInputGroupPrepend,
    BFormInput,
    BButton,

    VuePerfectScrollbar,
  },
  directives: {
    Ripple,
  },
  props: {
    curData: {
      type: Object,
      required: true,
    },
    items: {
      type: Array,
      required: true,
      default: [],
    },
  },
  watch: {
    curData() {
      // console.log("curData", this.curData);
    },
    items() {
      // console.log("items", this.items);
    },
  },
  methods: {
    initChecked(val) {
      let index = this.curData.listAction?.findIndex((x) => x == val)
      if (index == undefined || index == -1) {
        return false
      } else {
        return true
      }
    },
    handleChecked($event, action) {
      console.log('LOG ACTION : ', action, $event)
      if ($event == true) {
        console.log('LOG ACTION BEFORE : ', this.curData)
        this.curData.listAction.push(action)
      } else {
        let index = this.curData.listAction?.findIndex((x) => x == action)
        if (index != -1) {
          this.curData.listAction.splice(index, 1)
        }
      }
    },
    updateAction() {
      if (this.curData && this.curData.id) {
        UpdateAction(this.curData)
            .then((res) => {
              if (res.isError) {
                this.$toast({
                  component: ToastificationContent,
                  position: 'top-right',
                  props: {
                    title: 'Thất bại',
                    icon: 'AlertTriangleIcon',
                    variant: 'error',
                    text: res.message,
                  },
                })
              } else {
                this.$toast({
                  component: ToastificationContent,
                  position: 'top-right',
                  props: {
                    title: 'Thành công',
                    icon: 'CheckIcon',
                    variant: 'success',
                    text: res.message,
                  },
                })
                this.$emit('reload-list')
              }
            })
      }
    },
  },

  setup(props, { emit }) {
    const perfectScrollbarSettings = {
      maxScrollbarLength: 150,
    }

    return {
      perfectScrollbarSettings,
    }
  },
}
</script>

<style lang="scss" scoped>
.draggable-task-handle {
  position: absolute;
  left: 8px;
  top: 50%;
  transform: translateY(-50%);
  visibility: hidden;
  cursor: move;

  .todo-task-list .todo-item:hover & {
    visibility: visible;
  }
}
</style>

<style lang="scss">
@import "~@core/scss/base/pages/app-todo.scss";
@import "~@core/scss/base/pages/app-chat.scss";
@import "~@core/scss/base/pages/app-chat-list.scss";
</style>
